module.exports = __webpack_public_path__ + "img/Logo-Incubinnov_2.ebb1f4ef.png";